import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77118976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ccn-preferences-footer" }
const _hoisted_2 = { class: "ccn-preferences-footer__buttons" }
const _hoisted_3 = {
  key: 0,
  class: "ccn-preferences-footer__links"
}
const _hoisted_4 = ["href"]

import { EButtonMode } from '../../common/enums/button.enum';
  import links from '../../../configs/links';
  import CustomButton from './CustomButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PreferencesSectionFooter',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomButton, {
        class: "ccn-preferences-footer__button",
        mode: _unref(EButtonMode).TERTIARY,
        text: _ctx.$t(`${_ctx.$translationsUfeNamespace}buttons.saveSelection`),
        "onClick:button": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`click:ccn-accept-selection`)))
      }, null, 8, ["mode", "text"]),
      _createVNode(CustomButton, {
        class: "ccn-preferences-footer__button",
        mode: _unref(EButtonMode).PRIMARY,
        text: _ctx.$t(`${_ctx.$translationsUfeNamespace}buttons.acceptAll`),
        "onClick:button": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(`click:ccn-accept-all`)))
      }, null, 8, ["mode", "text"])
    ]),
    (_unref(links))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (!link.openPreferences)
                ? (_openBlock(), _createElementBlock("a", {
                    key: `ccn-preferences-${link.locizeIdentifier}`,
                    class: "ccn-preferences-footer__link",
                    href: link.href
                  }, _toDisplayString(_ctx.$t(`${_ctx.$translationsUfeNamespace}links.${link.locizeIdentifier}`)), 9, _hoisted_4))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})